import { render, staticRenderFns } from "./ReplenishTag.vue?vue&type=template&id=6e98a8d7"
import script from "./ReplenishTag.vue?vue&type=script&lang=js"
export * from "./ReplenishTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports